import React from "react";
import { useLanguage } from "@/context/LanguageContext";
import { useNotify } from "@/context/NotifyContext";
import { track } from "@/lib/analytics";

function AppleIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M16.365 1.43c0 1.14-.46 2.23-1.22 3.02-.81.84-2.04 1.49-3.18 1.4-.13-1.14.43-2.32 1.18-3.07.84-.84 2.13-1.45 3.22-1.35zM20.5 17.27c-.55 1.27-.81 1.84-1.51 2.96-.99 1.55-2.38 3.47-4.1 3.49-1.52.02-1.92-.99-3.99-.98-2.07.01-2.5 1-4.02.98-1.72-.02-3.04-1.75-4.03-3.3C1.13 17.18.59 13.62 2.34 11.04c1.24-1.82 3.2-2.88 5.05-2.88 1.88 0 3.07 1.03 4.62 1.03 1.5 0 2.42-1.03 4.6-1.03 1.64 0 3.38.89 4.61 2.43-4.05 2.22-3.39 8.01.28 8.68z" />
    </svg>
  );
}

function GoogleIcon() {
  return (
    <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M3.5 2.5c-.3.2-.5.6-.5 1v17c0 .4.2.8.5 1l9.6-9.5L3.5 2.5z" fill="currentColor" opacity="0.95"/>
      <path d="M16.8 8.4l-2.7 2.7 2.7 2.7 4.2-2.3c.8-.4.8-1.4 0-1.8l-4.2-2.3z" fill="currentColor"/>
      <path d="M13.1 11.1l-9.6 9.5c.3.2.7.2 1 0L16.8 14l-3.7-2.9z" fill="currentColor" opacity="0.85"/>
      <path d="M4.5 2.5c-.3-.2-.7-.2-1 0l9.6 9.6L16.8 8.4 4.5 2.5z" fill="currentColor" opacity="0.7"/>
    </svg>
  );
}

export default function AppStoreBadges({ className = "" }) {
  const { t } = useLanguage();
  const { openNotify } = useNotify();

  const handleClick = (store) => (e) => {
    e.preventDefault();
    track("store_badge_click", { store });
    openNotify(`store-${store}`);
  };

  return (
    <div className={`flex flex-wrap gap-3 ${className}`} data-testid="store-badges">
      <button
        type="button"
        data-testid="badge-apple"
        onClick={handleClick("apple")}
        className="store-badge"
        aria-label="Feaststar App im Apple App Store herunterladen — Bio, vegan und glutenfrei essen finden"
      >
        <AppleIcon />
        <span className="flex flex-col text-left">
          <span className="small">{t("storeBadges.appleSmall")}</span>
          <span className="large">{t("storeBadges.appleLarge")}</span>
        </span>
      </button>
      <button
        type="button"
        data-testid="badge-google"
        onClick={handleClick("google")}
        className="store-badge"
        aria-label="Feaststar App bei Google Play laden — Restaurants nach Ernährungspräferenzen finden"
      >
        <GoogleIcon />
        <span className="flex flex-col text-left">
          <span className="small">{t("storeBadges.googleSmall")}</span>
          <span className="large">{t("storeBadges.googleLarge")}</span>
        </span>
      </button>
    </div>
  );
}
